export enum PaybackPlan {
  AMOUNT = 'AMOUNT',
  PERCENTAGE = 'PERCENTAGE',
}

export const PaybackPlans = [
  { value: 'AMOUNT', label: 'Monatlicher Mindestbetrag' },
  { value: 'PERCENTAGE', label: 'Monatlicher Mindestprozentsatz' },
];
